<template>
  <section>
    <b-modal
      id="modalFillData"
      centered
      hide-footer
      hide-header
      size="xl"
      hide-actions
      no-close-on-backdrop
    >
      <section class="">
        <div
          class="p-3 p-lg-4"
        >
          <section class="c-fill-data d-flex">
            <div
              class="c-fill-data__vector d-none d-lg-flex justify-content-center
                align-items-center p-3 p-lg-4"
            >
              <figure>
                <img
                  class="w-100 h-100 of--contain"
                  src="@/assets/images/profile/welcome.png"
                  alt=""
                />
              </figure>
            </div>
            <div class="c-fill-data__body p-3 p-md-4 d-flex flex-column justify-content-between">
              <div class="mb-4">
                <h1 class="darks fs-21 w-bold">
                  ¡Bienvenido(a) a {{arcux.project.full}}!
                </h1>
                <p class="mb-4">Para continuar es necesario completar los siguientes datos</p>
                <div class="c-form c-form--ghost">
                  <div class="row mb-2">
                    <div class="col col-12 col-lg-6 mb-4">
                      <div
                        class="c-form-group"
                        :class="{'c-form-group--error': $v.profileData.field.$error}"
                      >
                        <p class="c-form__label mb-1">Campo de estudios</p>
                        <select
                          v-model="$v.profileData.field.$model"
                          class="c-form__select w-100"
                        >
                          <option value="" selected disabled>Selecciona un campo</option>
                          <option value="Arquitectura">Arquitectura</option>
                          <option value="Ingeniería Civil">Ingeniería Civil</option>
                          <option value="Diseño de Interiores">Diseño de Interiores</option>
                          <option value="Otro">Otro</option>
                        </select>

                        <span
                          class="c-form__error"
                          v-if="!$v.profileData.field.required"
                        >
                          Selecciona un campo de estudios
                        </span>
                      </div>
                    </div>
                    <div class="col col-12 col-lg-6 mb-4">
                      <div
                        class="c-form-group"
                        :class="{'c-form-group--error': $v.profileData.dateBorn.$error}"
                      >
                        <p class="c-form__label mb-1">Fecha de nacimiento</p>

                        <input
                          v-model="$v.profileData.dateBorn.$model"
                          type="date"
                          class="c-form__input w-100"
                          placeholder="ej. raul@ejemplo.com"
                        />

                        <span
                          class="c-form__error"
                          v-if="!$v.profileData.dateBorn.required"
                        >
                          Fecha de nacimiento incorrecta o vacía
                        </span>
                      </div>
                    </div>
                    <div class="col col-12">
                      <div
                        class="c-form-group"
                        :class="{'c-form-group--error': $v.profileData.id.$error}"
                      >
                        <p class="c-form__label mb-1">{{countryIds.current.label}}</p>

                        <div class="c-form__input-toggle">
                          <button class="c-initator c-tooltip-toggle d-flex align-items-center">
                            <Icon class="fs-21" icon="bx-bxs-help-circle" />
                          </button>
                          <input
                            v-model="$v.profileData.id.$model"
                            type="text"
                            class="c-form__input w-100"
                          />
                        </div>

                        <span
                          class="c-form__error"
                          v-if="!$v.profileData.id.required"
                        >
                          Dato vacio o invalido
                        </span>
                      </div>
                    </div>
                  </div>
                  <p class="mb-0 d-flex align-items-md-center">
                    <span>
                      <Icon class="fs-21 d-flex align-items-center" icon="bx-bxs-lock" />
                    </span>
                    <span class="fs-14 ms-2">
                      Toda tu información estará segura y nunca será compartida
                    </span>
                  </p>
                </div>
              </div>

              <div class="d-flex aligm-items-center justify-content-end">
                <button class="c-link c-link--black" @click="discardFillData">
                  Omitir
                </button>
                <button
                  class="c-button c-button--primary ms-3"
                  :disabled="isLoading"
                  :class="{ loading : isLoading }"
                  @click="saveUserData()"
                >
                  {{ (isLoading) ? 'Enviando...' : 'Enviar' }}
                  <img
                    class="c-button__spinner"
                    src="@/assets/images/animations/spinner-white.png"
                    alt="loading" />
                </button>
              </div>
            </div>
          </section>
        </div>
      </section>
    </b-modal>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import tippy from 'tippy.js';

export default {
  data() {
    return {
      arcux: { ...window.arcux },
      isLoading: false,

      countryCode: 'pe',
      countryIds: {
        current: {
          label: 'Documento Nacional de Identidad (DNI)',
        },
        pe: {
          label: 'Documento Nacional de Identidad (DNI)',
        },
        bo: {
          label: 'Cédula o Carné de identidad (CI)',
        },
        cr: {
          label: 'Cédula o Carné de identidad (CI)',
        },
        ec: {
          label: 'Cédula o Carné de identidad (CI)',
        },
        ni: {
          label: 'Cédula o Carné de identidad (CI)',
        },
        uy: {
          label: 'Cédula o Carné de identidad (CI)',
        },
        ve: {
          label: 'Cédula o Carné de identidad (CI)',
        },
        co: {
          label: 'Cédula de ciudadanía (CC)',
        },
        sv: {
          label: 'Documento único de identidad (DUI)',
        },
        gt: {
          label: 'Documento personal de identificación (DPI)',
        },
        hn: {
          label: 'Tarjeta de identidad (TDI)',
        },
        mx: {
          label: 'Clave Única de Registro de Población (CURP)',
        },
        pa: {
          label: 'Número de Cédula de Identidad Personal (CIP)',
        },
        do: {
          label: 'Cédula de Identidad y Electoral (CIE)',
        },
        pr: {
          label: 'Licencia de Conducir o Número de Seguro Social',
        },
        py: {
          label: 'Cédula de identidad Civil (CIC/CI)',
        },
        cl: {
          label: 'Cedula de identidad, Carnet, RUT o RUN',
        },
        ar: {
          label: 'CUIT, CUIL, CDI o DNI',
        },
      },

      profileData: {
        field: '',
        dateBorn: '',
        id: '',
      },

      profile: {},
    };
  },
  props: {
    user: Object,
  },
  validations: {
    profileData: {
      field: {
        required,
      },
      dateBorn: {
        required,
      },
      id: {
        required,
      },
    },
  },
  mounted() {
    if (!window.localStorage.getItem('arcux_fill_deadline')) {
      this.getUserData();
      this.getGeneralData();
    } else {
      const deadline = Number(window.localStorage.getItem('arcux_fill_deadline'));
      const now = (new Date()).getTime() / 1000;

      if (now >= deadline) {
        this.getUserData();
        this.getGeneralData();
      }
    }
  },
  methods: {
    initCountryID() {
      if (this.countryCode && this.countryIds[this.countryCode]) {
        this.countryIds.current.label = this.countryIds[this.countryCode].label;
      } else {
        this.countryIds.current.label = this.countryIds.pe.label;
      }
    },
    initTooltips() {
      window.setTimeout(() => {
        tippy('.c-tooltip-toggle', {
          content() {
            return `
            <div class="c-tooltip c-tooltip--tiny p-2">
              Ingresa el documento de identidad utilizado en tu pais. Este puede ser: <b>CI</b>, <b>CC</b>, <b>TI</b>, <b>TP</b>, <b>RC</b>, <b>CE</b>, <b>DNI</b>, <b>DUI</b>, <b>ID</b>, <b>RUT</b> u otros.
            </div>`;
          },
          allowHTML: true,
          animation: 'scale',
          hideOnClick: true,
          inertia: true,
          placement: 'top-end',
          theme: 'arcux-dark',
          trigger: 'click',
        });
      }, 2000);
    },
    closeModal() {
      this.$bvModal.hide('modalFillData');
    },

    getGeneralData() {
      fetch(`${window.arcux.api}/pages/data`)
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.countryCode = response.data.country_code;
          }
        })
        .catch(() => {});
    },
    getUserData() {
      const url = `${this.arcux.api}/users/${this.user.id}/profile`;

      fetch(url, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (!response.data.dni) {
            this.profileData.dateBorn = (response.data.date_born) ? response.data.date_born : '1990-12-31';

            this.initCountryID();
            this.initTooltips();

            this.$bvModal.show('modalFillData');
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    saveUserData() {
      this.$v.$touch();

      if (
        !this.$v.profileData.$invalid
      ) {
        this.isLoading = true;

        const url = `${this.arcux.api}/users/${this.user.id}/profile/complete`;

        fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${window.arcux.token}`,
          },
          body: JSON.stringify({
            dateBorn: this.profileData.dateBorn,
            dni: this.profileData.id,
            fieldStudy: this.profileData.field,
          }),
        })
          .then((res) => {
            if (res.status === 200 || res.status < 300) {
              return res.json();
            }

            throw res;
          })
          .catch((err) => {
            throw err;
          })
          .finally(() => {
            window.localStorage.removeItem('arcux_fill_deadline');

            window.setTimeout(() => {
              this.isLoading = false;

              this.closeModal();
            }, 1000);
          });
      }
    },
    discardFillData() {
      const deadline = ((new Date()).getTime() / 1000) + (12 * 3600);

      window.localStorage.setItem('arcux_fill_deadline', String(deadline));

      this.closeModal();
    },
  },
};
</script>
